module.exports = "/images/Mechanical---Screenshots.jpg";